// src/utils/validation.js

/**
 * Trims and lowercases email strings
 * @param {string} email 
 * @returns {string} Cleaned email
 */
export const sanitizeEmail = (email) => {
  return email?.trim().toLowerCase() || "";
};

/**
 * Validates required ID field
 * @param {string} id - The ID to validate
 * @param {string} name - Name of the field for error message
 */
export const validateRequiredId = (id, name = "ID") => {
  if (!id) throw new Error(`${name} is required`);
};

/**
 * Validates asset ID format
 * @param {string} assetId - Asset ID to validate
 * @returns {boolean} True if valid format
 */
export const validateAssetIdFormat = (assetId) => {
  return /^[A-Z]{3}-[A-Z]{2,5}-\d{5}$/.test(assetId);
};

/**
 * Extracts category code from asset ID
 * @param {string} assetId - Asset ID
 * @returns {string} Category code
 */
export const extractCategoryFromAssetId = (assetId) => {
  const match = assetId.match(/^[A-Z]{3}-([A-Z]{2,5})-\d{5}$/);
  return match ? match[1] : null;
};